import { ApolloClient, ApolloProvider, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import React from 'react';
import { ThemeProvider } from 'react-bootstrap';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import App from './App';
import { DataContextProvider } from './contexts/DataContext';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { NotificationProvider } from './contexts/NotificationContext';
import { authUserManager, getFreshAccessToken, startTokenRefreshMonitor } from './utils/auth';
import { startAppVersionMonitor } from './utils/appVersion';

startAppVersionMonitor({ appName: 'member-ui' });
startTokenRefreshMonitor();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

if (!window.sessionStorage.getItem('originalPath'))
    window.sessionStorage.setItem('originalPath', window.location.pathname);

const onSigninCallback = () => {
    const originalPath = window.sessionStorage.getItem('originalPath');
    window.location.href = originalPath && originalPath !== '/' ? originalPath : '/dashboard';
};

const httpLink = createHttpLink({
    uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
});

const authLink = setContext(async (_, { headers }) => {
    const accessToken = await getFreshAccessToken();

    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            authorization: accessToken ? `Bearer ${accessToken}` : '',
        },
    };
});

const commonConfig = {
    cache: new InMemoryCache(),
    connectToDevTools: true,
};

const client = new ApolloClient({
    ...commonConfig,
    link: authLink.concat(httpLink),
});

root.render(
    <React.StrictMode>
        <AuthProvider userManager={authUserManager} onSigninCallback={onSigninCallback}>
            <DataContextProvider>
                <ApolloProvider client={client}>
                    <ThemeProvider prefixes={{}}>
                        <NotificationProvider>
                            <App />
                        </NotificationProvider>
                    </ThemeProvider>
                </ApolloProvider>
            </DataContextProvider>
        </AuthProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
